export default "__VITE_ASSET__BdI5QJX6__"